<template>
  <div class="info-item">
    <div class="info-item__title">{{ label }}</div>
    <div class="info-item__value g-font-mid"><slot /></div>
  </div>
</template>

<script>

export default {
  name: 'InfoItem',
  props: {
    label: {
      type: String,
      require: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .info-item {
    display: inline-block;
    vertical-align: top;
    & + & {
      margin-left: 70px;
    }
  }

  .info-item__title {
    font-size: $font-size-sm;
    line-height: 14px;
    color: var(--color-content);
  }

  .info-item__value {
    margin-top: 10px;
    line-height: 16px;
    min-height: 16px;
  }
</style>
